import { RuleEngine } from '@8fig/rule-engine';
import { Feature } from './feature';
import { rollTheDice } from './utils/chance';
import {
  getPersistedFeatureResult,
  persistFeatureResult,
} from './utils/persister';
import mixpanel from '@8fig/mixpanel';
import { Cache } from './utils/cache';

const cache = new Cache<Promise<boolean>>();

export async function isFeatureEnabled(
  feature: Feature,
  ruleEngine: RuleEngine,
): Promise<boolean> {
  const persisted = getPersistedFeatureResult(feature);

  if (persisted !== undefined) {
    return persisted;
  }

  let enabled = false;

  if (rollTheDice(feature.percent)) {
    if (!feature.condition || (await ruleEngine.run(feature.condition))) {
      enabled = true;
      mixpanel.people.append('features', feature.name);
    }
  }

  persistFeatureResult(feature, enabled);

  return enabled;
}

export function chooseFeature(
  feature: Feature,
  ruleEngine: RuleEngine,
): Promise<boolean> {
  return cache.get(feature.name, () => isFeatureEnabled(feature, ruleEngine));
}
